/**
 * API types for the /companies endpoint
 * These types match the backend CompanyDto model in CreditControl.Models
 */

export interface CompanyApi {
  id: number;
  name: string;
  code: string | null;
  // Provisioning metadata (set during automatic provisioning)
  evoSubscriptionId: string | null;
  evoOrganisationId: string | null;
  // Integration linking (set when user manually links to external product)
  linkedSubscriptionId: string | null;
  linkedSubscriptionName: string | null;
  linkedProductId: string | null;
  linkedProductName: string | null;
  // Other properties
  currencyId: number | null;
  taxId: string | null;
  status: string;
  createdAt: string;
}

export interface CurrencyApi {
  id: number;
  code: string;
  name: string;
  symbol: string | null;
}

export interface CreateCompanyRequest {
  name: string;
  code?: string | null;
  currencyId?: number | null;
  taxId?: string | null;
  linkedSubscriptionId?: string | null;
  linkedSubscriptionName?: string | null;
  linkedProductId?: string | null;
  linkedProductName?: string | null;
}

export interface UpdateCompanyRequest {
  name: string;
  code?: string | null;
  currencyId?: number | null;
  taxId?: string | null;
  status: string;
}

export interface UpdateCompanyLinkRequest {
  linkedSubscriptionId?: string | null;
  linkedSubscriptionName?: string | null;
  linkedProductId?: string | null;
  linkedProductName?: string | null;
}

// Product IDs for linking
export const FINANCIALS_PRODUCT_ID = '1f6ad618-1714-4e09-aa5a-8a0b5f1b4bb4';
export const DIMENSIONS_VNEXT_PRODUCT_ID = '63cc79e9-e977-489a-aebe-3103d2076e16';
